import React from "react";
import { ToastContainer } from "react-toastify";
import { ManageArticles } from "../components/NewsManagement/Articles/ManageArticles";

export const ArticlesManage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageArticles />
        </div>
      </div>
    </div>
  );
};
